import { Link, NavLink } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { Languages } from "lucide-react";

const Navbar = () => {
  const { t, lang, toggleLang } = useLanguage();

  const linkClass = ({ isActive }) =>
    `font-body text-sm tracking-wide transition-colors hover:text-terracotta ${
      isActive ? "text-terracotta" : "text-ink/80"
    }`;

  return (
    <header className="border-b border-border bg-background/95 backdrop-blur sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 flex items-center justify-between gap-8">
        <Link to="/" className="flex items-center gap-3 group" data-testid="navbar-logo">
          <img
            src="/logo.png"
            alt="Les Amis de Lili"
            className="w-14 h-14 rounded-full object-cover ring-1 ring-border transition-transform group-hover:scale-105"
          />
          <div className="leading-tight">
            <div className="font-serif-display text-xl text-ink">Les Amis de Lili</div>
            <div className="font-script text-terracotta text-base -mt-1">{t.nav.tagline}</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={linkClass} data-testid="nav-home">
            {t.nav.home}
          </NavLink>
          <NavLink to="/catalogue" className={linkClass} data-testid="nav-catalog">
            {t.nav.catalog}
          </NavLink>
          <NavLink to="/about" className={linkClass} data-testid="nav-about">
            {t.nav.about}
          </NavLink>
        </nav>

        <button
          onClick={toggleLang}
          data-testid="nav-language-toggle"
          className="flex items-center gap-2 px-4 py-2 rounded-full border border-border hover:border-terracotta hover:bg-cream transition-all text-xs font-medium tracking-widest uppercase"
        >
          <Languages size={14} strokeWidth={1.5} />
          {lang === "fr" ? "EN" : "FR"}
        </button>
      </div>
    </header>
  );
};

export default Navbar;
